var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastrWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.0014C20 15.525 15.5228 20.0027 10 20.0027C4.47715 20.0027 0 15.525 0 10.0014C0 4.47777 4.47715 0 10 0C15.5228 0 20 4.47777 20 10.0014ZM8.75 10.8348C8.75 11.5253 9.30964 12.085 10 12.085C10.6904 12.085 11.25 11.5253 11.25 10.8348V5.00069C11.25 4.31024 10.6904 3.75051 10 3.75051C9.30964 3.75051 8.75 4.31024 8.75 5.00069V10.8348ZM8.75 15.0021C8.75 15.6925 9.30964 16.2522 10 16.2522C10.6904 16.2522 11.25 15.6925 11.25 15.0021C11.25 14.3116 10.6904 13.7519 10 13.7519C9.30964 13.7519 8.75 14.3116 8.75 15.0021Z",
    fill: "#FFA216"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastrWarning);
export default __webpack_public_path__ + "static/media/toastr-warning.9cc2b254.svg";
export { ForwardRef as ReactComponent };